export default function Footer() {
  return (
    <footer className="border-t border-border/50 bg-background/80 backdrop-blur-lg px-4 py-3">
      <div className="mx-auto max-w-5xl text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Shhh... Book Club. All rights reserved.
      </div>
    </footer>
  );
}
